import {
    CONTRACTOR_NON_ENGINEERS_REQUEST,
    CONTRACTOR_NON_ENGINEERS_SUCCESS,
    CONTRACTOR_NON_ENGINEERS_FAILURE,
    STORE_CONTRACTOR_NON_ENGINEER_REQUEST,
    STORE_CONTRACTOR_NON_ENGINEER_SUCCESS,
    STORE_CONTRACTOR_NON_ENGINEER_FAILURE,
    UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST,
    UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS,
    UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const CONTRACTOR_NON_ENGINEERS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null,
};

import nonEngineer from './contractor-non-engineer';
const nonEngineerReducer = (state, action) => {
    let {data} = state;
    const {nonEngineer: id} = action;
    const eng = data.find(b => b.id === id);
    const reduced = nonEngineer(eng, action);
    data.splice(data.indexOf(eng), 1, reduced);
    data = [...data];

    return {...state, data};
};

const nonEngineersReducers = {
    [CONTRACTOR_NON_ENGINEERS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_NON_ENGINEERS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_NON_ENGINEERS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_CONTRACTOR_NON_ENGINEER_REQUEST]: (state, action) => {
        const admin = nonEngineer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), admin];

        return {...state, data};
    },
    [STORE_CONTRACTOR_NON_ENGINEER_SUCCESS]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = nonEngineer(admin, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_CONTRACTOR_NON_ENGINEER_FAILURE]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = nonEngineer(admin, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST]: nonEngineerReducer,
    [UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS]: nonEngineerReducer,
    [UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE]: nonEngineerReducer,
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST]: nonEngineerReducer,
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: nonEngineerReducer,
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE]: nonEngineerReducer,
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST]: nonEngineerReducer,
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS]: nonEngineerReducer,
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE]: nonEngineerReducer,
};

export default function nonEngineers(state = CONTRACTOR_NON_ENGINEERS_INITIAL_STATE, action) {
    let reducer = nonEngineersReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-non-engineers.js